import { Component, Inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components';
import { DisruptionMessage, DisruptionMessageSeverity } from '@ridango/core';
import { DisruptionMessageDetailsComponent } from '../disruption-message-details/disruption-message-details.component';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-disruption-message',
    templateUrl: './disruption-message.component.html',
    styleUrls: ['./disruption-message.component.scss']
})
export class DisruptionMessageComponent {
    @Input() disruptionMessage: DisruptionMessage;
    @Input() commonExtraClasses: string | string[] = '';
    @Input() commonExtraSpanClasses: string | string[] = '';
    DisruptionMessageSeverity = DisruptionMessageSeverity;
    assetsPath$ = this.applicationFacade.assetsPath$;
    constructor(
        protected applicationFacade: ApplicationFacade,
        private modalCtrl: ModalController,
        @Inject('ENV') public env: Env
    ) {}

    async openDisruptionMessageDetailsView(message: DisruptionMessage) {
        const modal = await this.modalCtrl.create({
            component: DisruptionMessageDetailsComponent,
            componentProps: {
                disruptionMessage: message
            }
        });

        modal.componentProps = {
            ...modal.componentProps,
            modalRef: modal
        };

        await modal.present();
    }
}
